/**
 * Custom LP — スタイリング画像の PhotoSwipe ライトボックス
 * `.custom-lp-styling-gallery` を複数置いても 1 回の init で全ギャラリーを扱う（PhotoSwipe が各要素にリスナーを付与）
 */
import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js';

const GALLERY_SELECTOR = '.custom-lp-styling-gallery';
const CHILD_SELECTOR = 'a';

const ARROW_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M184 112l144 144-144 144"></path></svg>';

function initCustomLpStylingGalleries() {
  if (!document.querySelector(GALLERY_SELECTOR)) {
    return null;
  }

  const lightbox = new PhotoSwipeLightbox({
    gallery: GALLERY_SELECTOR,
    children: CHILD_SELECTOR,
    pswpModule: () => import('./photoswipe.esm.min.js'),
    showHideAnimationType: 'fade',
    arrowPrevSVG: ARROW_SVG,
    arrowNextSVG: ARROW_SVG,
    mainClass: 'pswp--custom-lp',
    loop: false,
  });

  // data-pswp-width/height を固定しない: サムネと同一URLの実寸比を使う（未ロード時はキャッシュヒット分のみ同期取得）
  lightbox.addFilter('domItemData', (itemData, _element, linkEl) => {
    const link = linkEl;
    if (!link) return itemData;

    const hasManual =
      link.dataset.pswpWidth &&
      link.dataset.pswpHeight &&
      Number(link.dataset.pswpWidth) > 0 &&
      Number(link.dataset.pswpHeight) > 0;
    if (hasManual) return itemData;

    const thumb = link.querySelector('img');
    let w = 0;
    let h = 0;

    if (thumb && thumb.naturalWidth > 0 && thumb.naturalHeight > 0) {
      w = thumb.naturalWidth;
      h = thumb.naturalHeight;
    } else if (itemData.src) {
      const probe = new Image();
      probe.src = itemData.src;
      if (probe.complete && probe.naturalWidth > 0 && probe.naturalHeight > 0) {
        w = probe.naturalWidth;
        h = probe.naturalHeight;
      }
    }

    if (w > 0 && h > 0) {
      itemData.w = w;
      itemData.h = h;
      itemData.width = w;
      itemData.height = h;
    }

    return itemData;
  });

  lightbox.init();
  return lightbox;
}

initCustomLpStylingGalleries();
